import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const t = {
  number: '{number, plural, one {{number} order} other {{number} orders}}',
};

const ShipperOrderTableGroupTitle = React.memo(({ intl, className, number, value }) => {
  const dateFormats = intl.messages.date_formats;
  return (
    <div className={className}>
      <h2>{moment(value).calendar(null, dateFormats.table_calendar)} </h2>
      {!!number && (
        <div>
          (
          <FormattedMessage
            id="containers.Jobs.number_of_jobs"
            defaultMessage={t.number}
            values={{
              number: String(number),
            }}
          />
          )
        </div>
      )}
    </div>
  );
});

ShipperOrderTableGroupTitle.propTypes = {
  intl: PropTypes.shape({}),
  className: PropTypes.string,
  value: PropTypes.string,
  number: PropTypes.number,
};

export default ShipperOrderTableGroupTitle;
